import { SidebarItemsType } from "@/types/sidebar";

import {
  BookOpen,
  Briefcase,
  Calendar,
  CheckSquare,
  CreditCard,
  Grid,
  Heart,
  Layout,
  List,
  Map,
  ShoppingCart,
  Package,
  PieChart,
  Sliders,
  Users,
} from "lucide-react";

const pagesSection = [
  {
    href: "/profile",
    icon: Layout,
    title: "Profile",
  },
  {
    href: "/initial-questionnaire",
    icon: Layout,
    title: "Initial Questionnaire",
  },
  {
    href: "/academics",
    icon: Layout,
    title: "Academics",
  },
  {
    href: "/extracurricular-activities",
    icon: Layout,
    title: "Extracurricular Activities",
  },
  {
    href: "/awards",
    icon: Layout,
    title: "Awards",
  },
  {
    href: "/school-results",
    icon: Layout,
    title: "School Results",
  },
] as SidebarItemsType[];

const navItems = [
  {
    pages: pagesSection
  },
];



export default navItems;

export {
  pagesSection
}